import { z } from 'zod';

import { UploadState } from './upload-status';

export type UpdateUploadStatusPayload = z.infer<typeof updateUploadStatusPayloadSchema>;

export const updateUploadStatusPayloadSchema = z.object({
  state: z.enum([UploadState.FROZEN, UploadState.IN_PROGRESS]),
});
